<div class="grid grid-cols-1 sm:grid-cols-2 text-gray-500">
  <p class="mt-2 text-sm text-gray-500 inline-flex">
    <app-cross-check-display [DarkMode]="darkMode" [Valid]="hasUpperRequirement" [Text]="'Großbuchstabe'"
                             [IconSide]="Side.Left"/>
  </p>
  <p class="mt-2 text-sm text-gray-500 sm:text-right">
    <app-cross-check-display [DarkMode]="darkMode" class="hidden sm:block" [Valid]="hasLowerRequirement"
                             [Text]="'Kleinbuchstabe'" [IconSide]="Side.Right"/>
    <app-cross-check-display [DarkMode]="darkMode" class="sm:hidden" [Valid]="hasLowerRequirement"
                             [Text]="'Kleinbuchstabe'" [IconSide]="Side.Left"/>
  </p>
  <p class="mt-2 text-sm text-gray-500">
    <app-cross-check-display [DarkMode]="darkMode" [Valid]="hasNumbersRequirement" [Text]="'Zahl'"
                             [IconSide]="Side.Left"/>
  </p>
  <p class="mt-2 text-sm text-gray-500 sm:text-right">
    <app-cross-check-display [DarkMode]="darkMode" class="hidden sm:block" [Valid]="hasSpecialRequirement"
                             [Text]="'Sonderzeichen:&nbsp;!@#$&*'" [IconSide]="Side.Right"/>
    <app-cross-check-display [DarkMode]="darkMode" class="sm:hidden" [Valid]="hasSpecialRequirement"
                             [Text]="'Sonderzeichen:&nbsp;!@#$&*'" [IconSide]="Side.Left"/>
  </p>
  <p class="mt-2 text-sm text-gray-500">
    <app-cross-check-display [DarkMode]="darkMode" [Valid]="hasLengthRequirement" [Text]="'8-32&nbsp;Zeichen'"
                             [IconSide]="Side.Left"/>
  </p>
</div>
